<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="success" plain @click="onExport" v-if="$permission.canExport()">导出</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{row}">
            <el-button type="text" @click="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <detail-dialog ref="detailDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/mall/order/all/list";
import detailDialog from "@/components/mall/order/all/detailDialog";

export default {
  name: "order_all",
  mixins: [curdMixins],
  components: {
    list,
    detailDialog,
  },
  methods: {
    details(row) {
      this.$refs.detailDialog.openDetails(row);
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>